import { useEffect, useState } from "react";
import { Box } from "@chakra-ui/react";
import maplibregl, { Map } from "maplibre-gl";
import { captureException } from "@sentry/nextjs";

import { ILocationSuggestion, IGeoBounds } from "utils/geo/types";
import Location2Json from "utils/geo/api/Location2Json";
import useApiEndpoint from "hooks/useApiEndpoint";

const LocationMap: React.FC<{
  village: ILocationSuggestion;
  street: ILocationSuggestion;
}> = ({ village, street }) => {
  const { callEndpoint: location2json } = useApiEndpoint(Location2Json);
  const [bounds, setBounds] = useState<IGeoBounds | null>(null);

  useEffect(() => {
    if (!village || !street) {
      setBounds(null);

      return;
    }
    try {
      const callLocation2json = async () => {
        try {
          const { data } = await location2json({
            location: `${village.label}, ${street.label}`,
          });

          if (data) {
            setBounds(data.bounds);
          }
        } catch (err) {
          captureException(err);
        }
      };

      callLocation2json();
    } catch (err) {
      captureException(err);
    }
  }, [village.id, street.id]);

  useEffect(() => {
    if (bounds) {
      const mapInst = new Map({
        container: "newoffer-mapbox", // container id
        style: "https://tiles.ulovdomov.cz/styles/basic-preview/style.json",
        center: [bounds.southWest.lng, bounds.northEast.lat], // starting position [lng, lat]
        zoom: 15, // starting zoom,
        boxZoom: true,
        interactive: true,
      });
      mapInst.on("load", () => {
        mapInst.addControl(new maplibregl.NavigationControl({}));
        const marker = new maplibregl.Marker({ color: "#E94932" });

        marker.setLngLat([bounds.southWest.lng, bounds.northEast.lat]);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        marker.addTo(mapInst);
      });
    }
  }, [bounds]);

  if (!bounds) {
    return null;
  }

  return (
    <Box
      w="100%"
      height="170px"
      mb="16px"
      borderRadius="8px"
      id="newoffer-mapbox"
      data-test="global.mapBox"
    />
  );
};

export default LocationMap;
